module.exports = ".mat-form-field {\n  width: 130px; }\n"